/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:55
 */
import Column from './Column';
import toasts from '../toasts/ToastManager';
import Mousetrap from 'mousetrap';

class RichTextColumn extends Column {

  constructor(params) {
    super(params);
    this.dirtyUnloadNotifier = params.dirtyUnloadNotifier;
    this.init();
  }

  init() {
    const $elements = this.elements();

    const map = {
      'allowed-content': 'allowedContent',
      'extra-allowed-content': 'extraAllowedContent',
      'styles-set': 'stylesSet',
      'format-tags': 'format_tags',
      'filebrowser-image-browse-url': 'filebrowserImageBrowseUrl',
      'filebrowser-browse-url': 'filebrowserBrowseUrl',
      'contents-css': 'contentsCss'
    };

    for (let i = 0; i < $elements.length; i++) {
      let $elt = $($elements[i]);
      let params = {
        filebrowserWindowWidth: 1000,
        filebrowserWindowHeight: 600
      };
      for (let key in map) {
        if (map.hasOwnProperty(key)) {
          if (typeof $elt.data(key) !== typeof undefined && ($elt.data(key) !== "" || key === 'extra-allowed-content')) {
            params[map[key]] = $elt.data(key);
          }
        }
      }

      let id = $($elements[i]).attr('id');
      let editor = CKEDITOR.replace(id, params);

      editor.on('notificationShow', (ev) => {
        ev.cancel();
        toasts().info(ev.data.notification.message);
      });

      editor.on('loaded', (ev) => {
        this.showLoader(ev.sender.name, false);
        this.showPlaceholder(ev.sender.name, false);
      });

      editor.on('instanceReady', (ev) => {
        Mousetrap(editor.document.$).bind('mod+s', function(event, combo) {
          event.preventDefault();
          Mousetrap.trigger('mod+s');
        });
      });

      editor.on('change', (ev) => {
        this.dirtyUnloadNotifier.setDirty();
      });
    }
  };

  destroy() {
    const $elements = this.elements();

    for (let i = 0; i < $elements.length; i++) {
      let id = $($elements[i]).attr('id');
      if (CKEDITOR.instances.hasOwnProperty(id)) {
        CKEDITOR.instances[id].destroy();
      }
    }

    return this;
  }

  elements() {
    return this.$root.find('.js-rich-text');
  }

  startSorting() {
    this.destroy();
    this.showAllPlaceholders();
    return this;
  }

  stopSorting() {
    this.init();
    return this;
  }

  showAllPlaceholders(doShow = true) {
    const $elements = this.elements();
    for (let i = 0; i < $elements.length; i++) {
      this.showPlaceholder($($elements[i]).attr('id'), doShow);
    }
  }

  showPlaceholder(id, doShow = true) {
    const placeholder = document.querySelector(`.js-cke-placeholder[data-for="${id}"]`);
    placeholder.style.setProperty('display', doShow ? 'flex' : 'none', 'important');
  }

  showLoader(id, doShow = true) {
    const $placeholder = $(`.js-cke-placeholder[data-for="${id}"]`);
    const $loader = $placeholder.find('.js-state--pending');
    if (doShow) {
      $loader.removeAttr('style');
    } else {
      $loader.css('display', 'none');
    }
  }

}

export default RichTextColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/RichTextColumn.js